// Keeps "name" fields text-only — letters, spaces, and the handful of
// punctuation marks real names use (apostrophe, hyphen, period).
export const sanitizeNameInput = (value) => value.replace(/[^A-Za-z\s'.-]/g, "");
